module.exports = "/images/ny-blck-1.jpg";